import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { RxFormGroup } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {
  @ViewChild('inputElement') inputElement: ElementRef;
  @Input() formParent: RxFormGroup;
  @Input() placeholder: string;
  @Input() frmControl: string;
  @Input() type: string;
  @Input() label: string;
  @Input() isIcon = false;
  @Input() icon: string;
  @Input() isTextArea: false;
  @Input() isOnlyInput: false;  
  @Input() setValue: number;
  @Input() isReadOnly = false;
  @Input() format: string;
  @Input() maxDigits: string;

  control: AbstractControl;
  selected = false;
  
  @Output() value = new EventEmitter<object>();
  @Output() blurEvent = new EventEmitter<void>();

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.control = this.formParent.controls[this.frmControl];
  }

  focusOutInput(): void {
    this.blurEvent.emit();
  }

  focusInput(): void {
    this.selected = true;
  }
  togglePassword() {
    this.type = this.type === 'password' ? 'text' : 'password';
    let cursorPosition = this.inputElement.nativeElement.selectionStart;
    setTimeout(() => {
      this.inputElement.nativeElement.focus();
      this.inputElement.nativeElement.setSelectionRange(cursorPosition, cursorPosition);
    });
  }

  keyupInput(event: any): void {
      this.value.emit(this.formParent.controls[this.frmControl].value);
  }

  focusOnInputText(): void {
    this.inputElement.nativeElement.focus();
  }

}
